import { GET_ALL_FILE_MANAGER_FILES, UPLOAD_FILE } from "./types";
import firebase from "firebase/app";
import moment from "moment";
import { push } from "connected-react-router";
export const getAllFiles = () => {
    return dispatch => {
        dispatch({ type: GET_ALL_FILE_MANAGER_FILES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(async user => {
                if (user) {
                    let files = await getFiles();
                    dispatch({
                        type: GET_ALL_FILE_MANAGER_FILES.SUCCESS,
                        payload: files
                    });
                } else {
                    dispatch({ type: GET_ALL_FILE_MANAGER_FILES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_ALL_FILE_MANAGER_FILES.FAIL });
        }
    };
};

export const uploadFile = (file = false, successCallback, newAttachedFile) => {
    return async dispatch => {
        dispatch({ type: UPLOAD_FILE.REQUEST });
        let newFileID = await getNewFileID();
        let fileExists = await doesFileExist(file.name, "method_statements");

        try {
            if (!fileExists) {
                let upload = firebase
                    .storage()
                    .ref(`file_manager/job_pack_files`)
                    .child(file.name)
                    .put(file);

                upload.on(
                    "state_changed",
                    snapshot => {
                        let progress =
                            (snapshot.bytesTransferred / snapshot.totalBytes) *
                            100;

                        successCallback({
                            fileExists: false,
                            inProgress: true,
                            finished: false,
                            error: false,
                            progress: progress,
                            msg: "Upload is " + progress + "% done"
                        });
                    },
                    () => {
                        successCallback({
                            fileExists: false,
                            inProgress: false,
                            finished: false,
                            error: true,
                            msg: "Something went wrong with this upload!"
                        });
                        dispatch({ type: UPLOAD_FILE.FAIL });
                    },
                    () => {
                        upload.snapshot.ref.getDownloadURL().then(url => {
                            let newFile = {
                                file_id: newFileID,
                                file_name: file.name,
                                file_size: file.size,
                                file_url: url,
                                file_type: file.type,
                                date_added: new moment().format(
                                    "DD-MM-YYYY hh:mm:ss"
                                ),
                                file_folder: "method_statements",
                                file_directory: "method_statements"
                            };
                            newAttachedFile({ file: file.name, fileURL: url });
                            firebase
                                .database()
                                .ref(`/subjects/file_manager/${newFile.file_directory}/${newFileID}/`)
                                .set(newFile)
                                .then(() => {
                                    dispatch({
                                        type: UPLOAD_FILE.SUCCESS
                                    });
                                    successCallback({
                                        fileExists: false,
                                        inProgress: false,
                                        finished: true,
                                        error: false,
                                        msg: "Success"
                                    });
                                });
                        });
                    }
                );
            } else {
                successCallback({
                    fileExists: true,
                    inProgress: false,
                    finished: false,
                    error: false,
                    msg: "Exists"
                });
                dispatch({ type: UPLOAD_FILE.FAIL });
            }
        } catch {
            dispatch({ type: UPLOAD_FILE.FAIL });
        }
    };
};
export const redirectTo = link => {
    return dispatch => {
        dispatch(push(link));
    };
};
export const getNewFileID = async () => {
    let files = await getFiles();

    let newFileID;
    if (files) {
        let IDs = Object.keys(files).map(e => {
            return  Object.values(files[e]).map(f => {
                 return f.file_id
             })
         })
         let fileIDs =  Math.max(...[].concat(...IDs));
         newFileID = (Number(fileIDs) + 1).toString().padStart(6, "0");
        return newFileID;
    } else if (files == null) {
        newFileID = "000001";
        return newFileID;
    }
};
export const doesFileExist = async (name, directory) => {
    let files = await getFiles();

    let flag = false;
    if (files) {
        Object.keys(files).map(index => {
            if (
                files[index].file_name === name &&
                files[index].file_directory === directory
            )
                flag = true;
            return null;
        });

        return flag;
    } else if (files == null) {
        return false;
    }
};
export const getFiles = async () => {
    let files = await firebase
        .database()
        .ref(`subjects/file_manager`)
        .once("value");
    return files.val();
};
export const  goToLink = url => {
    return dispatch => {
        dispatch(push(url));
    };
};